<template>
    <el-dialog
            :title="title"
            :visible="showLevel"
            :close-on-click-modal="!showLevel"
            :before-close="close"
            width="600px"
    >
        <div class="Field">
            <el-form ref="form" :model="LevelModel" label-width="120px" :rules="rules">
                <el-form-item label="领域名称" prop="productDomainId">
                    <el-select v-model="LevelModel.productDomainId" placeholder="请选择" style="width: 410px"  filterable :disabled="seldisable" @change="getdropList(1,LevelModel.productDomainId)">
                        <el-option v-for="item in oneLevel" :key="item.id" :label="item.name" :value="item.id" style="width:300px">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属一级产品" prop="firstProductId" v-if="levelType==2 || levelType==3">
                    <el-select  v-model="LevelModel.firstProductId" placeholder="请选择" style="width: 410px"  filterable  :disabled="seldisable" @change="getdropList(2,LevelModel.firstProductId)">
                        <el-option v-for="item in twoLevel" :key="item.id" :label="item.name" :value="item.id" style="width:300px">
                        </el-option>
                    </el-select>
                </el-form-item>
<!--                :disabled="true"-->
                <el-form-item label="所属二级产品" prop="secondProductId" v-if="levelType==3">
                    <el-select  v-model="LevelModel.secondProductId" :disabled="seldisable" filterable placeholder="请选择" style="width: 410px" >
                        <el-option v-for="item in threeLevel" :key="item.id" :label="item.name" :value="item.id" style="width:300px">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" prop="name" class="m-t-20">
                    <span slot="label">{{fontnum}}级产品名称</span>
                    <el-input type="text" v-model.trim="LevelModel.name" maxlength="100" :placeholder="'请输入'+fontnum+'级产品名称，不超过100字'" class="edit_input" style="width: 410px" @input="inpChange($event)"></el-input>
                </el-form-item>
                <el-form-item label="" prop="productLogo" class="mask m-t-20">
                    <span slot="label">{{fontnum}}级产品图片</span>
                    <el-upload
                            :action="url"
                            list-type="picture-card"
                            accept=".jpg, .jpeg, .png,.gif,.bmp"
                            :file-list="fileList"
                            :limit="imgLimitNum"
                            :before-upload="beforeAvatarUpload"
                            :on-exceed="handlePicOutLimit"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove"
                            :on-success="successUpload"
                            :class="{hide:hideUpload}">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <span class="tips">请上传gif、png、jpg、jpeg、bmp格式文件</span>
                </el-form-item>
                <el-form-item label="备注" prop="description" class="m-t-20">
                    <el-input type="textarea" v-model.trim="LevelModel.description" maxlength="1000" placeholder="请输入备注，不超过1000字" class="edit_input" style="width: 410px"></el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer" style="text-align: center;margin-top: 50px;" slot="footer">
                <el-button type="primary" @click="push('form')">确认</el-button>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </el-dialog>
</template>

<script>
    import apiEnv from "@/service/apiEnv.js";
    import { getproSelect,addproduct,editPro} from "@/service/dataFrame";
    import { getStorageUserRoleId } from '@/utils/store'
    export default {
        name: "addLevel",
        props:{
            currentParam:{
                type:Object,
                default(){return {}}
            }
        },
        data(){
            const valname = (rule, value, callback) => {
                if (!this.LevelModel.name) {
                    if (this.levelType == 1) {
                        callback(new Error('一级产品名称不能为空!'));
                    } else if (this.levelType == 2) {
                        callback(new Error('二级产品名称不能为空!'));
                    } else if (this.levelType == 3) {
                        callback(new Error('三级产品名称不能为空!'));
                    }
                } else {
                    callback();
                }
            };
            const valprologo = (rule, value, callback) => { // 图片验证
                if (!this.LevelModel.productLogo) {
                    callback(new Error(this.fontnum+'级产品图片不能为空!'));
                } else {
                    callback();
                }
            }
            return{
                showLevel:true,
                LevelModel:{
                    productDomainId:'',
                    firstProductId:'',
                    secondProductId:'',
                    name:'',
                    description:'',
                    productLogo:''
                },
                title:'',
                levelType:0,
                oneLevel:[],
                twoLevel:[],
                threeLevel:[],
                rules:{
                    productDomainId: [{required:true, message: '请选择领域名称！', trigger: 'change'}],
                    firstProductId: [{required:true, message: '请选择所属一级产品！', trigger: 'change'}],
                    secondProductId: [{required:true, message: '请选择所属二级产品！', trigger: 'change'}],
                    name: [{required:true, validator:valname, trigger: 'blur'}],
                    productLogo:[{required:true,validator:valprologo, trigger: 'change'}]
                },
                fontnum:'',
                url: apiEnv.uploadURL,
                imgLimitNum:1,
                fileList:[],
                dialogVisible:false,
                dialogImageUrl: "",     //点击查看的url
                hideUpload:false,
                seldisable:false,
                newparam:{}
            }
        },
        methods:{
            close(){
                this.$emit("close")
            },
            push(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        if(this.newparam.update==-1){
                            let param={
                                description:this.LevelModel.description,
                                productDomainId:this.LevelModel.productDomainId,
                                levelType:this.levelType,
                                name:this.LevelModel.name,
                                productLogo:this.LevelModel.productLogo,
                                userId:getStorageUserRoleId()
                            }
                            if(this.levelType==2){
                                param.firstProductId=this.LevelModel.firstProductId
                            }
                            if(this.levelType==3){
                                param.firstProductId=this.LevelModel.firstProductId;
                                param.secondProductId=this.LevelModel.secondProductId
                            }
                            // console.log('校验通过',param)
                            addproduct(param).then((res)=>{
                                if(res.Result != 1) {
                                    return this.$message.error(res.Message)
                                }
                                this.$emit("close")
                                this.$message.success("新增成功")
                                this.$emit("refreshList")
                            })
                        }else {
                            let param= {
                                description:this.LevelModel.description,
                                id:this.newparam.id,
                                levelType:this.levelType,
                                name:this.LevelModel.name,
                                productLogo:this.LevelModel.productLogo,
                            }
                            editPro(param).then((res)=>{
                                if(res.Result != 1) {
                                    return this.$message.error(res.Message)
                                }
                                this.$emit("close")
                                this.$message.success("修改成功")
                                this.$emit("refreshList")
                            })
                        }

                    }
                })
            },
            beforeAvatarUpload(file){
                var file_ext = file.name.substring(file.name.lastIndexOf(".") + 1);//获取后缀
                file_ext = file_ext.toLowerCase(); //都改成小写
                const isJPEG = file_ext === 'jpeg' || file_ext ==='jpg' || file_ext ==='gif' || file_ext === 'png' || file_ext === 'bmp'
                const isLt2M = file.size / 1024 / 1024 < 2,
                    limitStr = ['《','》','%','#','*',";","[","]","【","】",'{','}',"&","$"],
                    bool = limitStr.find((x)=>{return file.name.indexOf(x)>-1})?false:true;
                if (!isJPEG) {
                    this.$message.error('请上传正确的文件格式');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 10MB!');
                }
                if(!bool){
                    this.$message.error('图片命名不得包含非法字符!');
                }
                return isLt2M && bool && isJPEG;
            },
            handlePicOutLimit(){
                this.$message.warning("最多只能上传一张图片哦！")
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = "";
                this.dialogImageUrl = file.response ?
                    file.response.Data[0].imgUrl :
                    file.url;
                this.dialogVisible = true;
            },
            handleRemove(file, fileList) {
                this.LevelModel.productLogo = ''
                this.$refs.form.validateField(['productLogo'])
                this.hideUpload = false;
                // console.log(file, fileList);
            },
            successUpload(res){
                if(res.Result != 1) {
                    this.fileList = []
                    this.$refs.form.validateField('productLogo');
                    return this.$message.error(res.Message)
                }
                let simageUrl =res.Data[0].imgUrl
                this.LevelModel.productLogo =simageUrl;
                this.$refs.form.clearValidate('productLogo');
                this.hideUpload = true;
            },
            getdropList(data,updata){
                let param={
                    levelType:data
                }
                if(data>0){
                    param.superiorId=updata
                }
                getproSelect(param).then((res)=>{
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    if(data==0){
                        this.oneLevel=res.Data;
                        this.twoLevel=[];
                        this.threeLevel=[];
                    }
                    if(data==1){
                        this.twoLevel=res.Data;
                        if(this.currentParam.update ==-1) {
                            this.LevelModel.firstProductId='';
                            this.LevelModel.secondProductId='';
                        }
                        this.threeLevel=[];
                    }
                    if(data==2){
                        this.threeLevel=res.Data;
                        if(this.currentParam.update ==-1) {
                            this.LevelModel.secondProductId='';
                        }
                    }
                    // console.log("下拉",res.Data)
                })
            },
            inpChange (e) {
                this.$forceUpdate()
            }
        },
        mounted() {
           if(this.currentParam){
               const param = JSON.parse(JSON.stringify(this.currentParam));
               this.newparam = param;
               this.levelType = param.levelType;
               if(param.update==-1){
                   if (this.levelType == 1) {
                       this.title = '新增一级产品';
                       this.fontnum = '一';
                   } else if (this.levelType == 2) {
                       this.title = '新增二级产品';
                       this.fontnum = '二';
                   } else {
                       this.title = '新增三级产品';
                       this.fontnum = '三';
                   }
               } else {
                   this.title = '修改产品';
                   this.LevelModel={
                           productDomainId:param.productDomainId,
                           firstProductId:param.firstProductId,
                           secondProductId:param.secondProductId,
                           description:param.description,
                           productLogo:param.productLogo
                   }
                   if (this.levelType == 1) {
                       this.fontnum = '一';
                       this.LevelModel.name=param.firstProductName;
                       
                   } else if (this.levelType == 2) {
                       this.fontnum = '二';
                       this.LevelModel.name=param.secondProductName;
                       
                   } else {
                       this.fontnum = '三';
                       this.LevelModel.name=param.thirdProductName;
                   }
                   this.$nextTick(()=>{
                       // debugger
                       this.fileList = [{
                           name:'',
                           url:param.productLogo
                       }]
                       if(this.fileList.length>0){
                           this.hideUpload = true;
                       }
                   })
                   this.seldisable=true;
                   this.getdropList(1,this.LevelModel.productDomainId);
                   this.getdropList(2,this.LevelModel.firstProductId)
               }
               this.getdropList(0,0);
           }
        }
    }
</script>

<style lang="scss">
    .Field {
        .hide .el-upload--picture-card {
            display: none;
        }
    }
</style>
